module.exports = __webpack_public_path__ + "media/newstyle/images/happy-man-using-his-tablet-home-couch_2-a48995ee8f95bf07dcefde64cb396c6a.png";